import {Component, Input} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'publication-page',
  templateUrl: 'publication-page.component.html',
  styleUrls: ['publication-page.component.scss']
})
export class PublicationPageComponent {
  @Input() page: any;
  @Input() editMode: boolean;

  constructor(
    private router: Router
  ) {
  }

  get poster(){
    return this.page.posters?.data[0]?.links.open+'/render?width=468';
  }

  get posters() {
    return this.page.posters?.data;
  }

  public config= {
    // slidesPerView: 3,
    // centeredSlides: true,
    // spaceBetween: 30,
    // spaceBetween: 10,

    // slidesPerView: 'auto',
  }

  back(): void {
    window.history.back();
}

  ngOnInit() {
  }
}
